import { RouteUrl } from './route.url';

/**
 * All modules urls
 */
export const MODULES_URLS = {
  order: new RouteUrl(['order']),
  public: new RouteUrl(['public']),
};
